import $ from 'jquery'

let $body = $('body')
let $menu = $body.find('#navbar-menu')

export default () => {
    $(document).on('keyup', menuCloseHandler)
    $body.on('click', menuCloseHandler)
    $('.navbar-toggler').on('click', menuOpenHandler)
    $(window).on('scroll', stickyHeader)
    $menu.on('show.bs.collapse', menuShowHandler).
        on('hide.bs.collapse', menuHideHandler).
        on('click', (e) => {
            e.stopPropagation()
        })
}

function menuOpenHandler () {
    if ($body.hasClass('menu-open')) {
        closeMenu()
    } else {
        openMenu()
    }
}

function menuCloseHandler (e) {
    if (!$body.is('.menu-open')) {
        return
    }

    let close = false

    // Close on button click
    if (e.type === 'click') {
        e.preventDefault()
        close = true
    }

    // Close on esc
    if (e.type === 'keyup' && e.keyCode === 27) {
        close = true
    }

    if (close) {
        closeMenu()
    }
}

function openMenu () {
    $menu.collapse('show')
}

function closeMenu () {
    $menu.collapse('hide')
}

function menuShowHandler () {
    $body.addClass('menu-open')
}

function menuHideHandler () {
    $body.removeClass('menu-open')
}

function stickyHeader () {
    if ($(window).scrollTop() > 50) {
        $body.addClass('sticky-header')
    } else {
        $body.removeClass('sticky-header')
    }
}
